var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "h-120 relative flex flex-col justify-between w-full mx-0 md:mx-auto lg:mx-0 bg-white border-2 border-gray-200 rounded-lg shadow-md",
    },
    [
      _c("a", { staticClass: "flex-initial", attrs: { href: _vm.url } }, [
        _c("img", {
          staticClass: "w-full !h-44 object-cover",
          attrs: { src: _vm.imageUrl, alt: "inventory image", loading: "lazy" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grow px-4 py-2" }, [
        !_vm.isNew
          ? _c(
              "div",
              { staticClass: "flex flex-col" },
              [
                _vm.categoryLink
                  ? _c("div", { staticClass: "flex flex-col mb-2" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "self-start border border-green-500 text-green-500 text-xs uppercase border-we-light border p-1 px-3 rounded-xl leading-none w-fit max-w-max",
                          attrs: { href: _vm.categoryLink },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onNavToCategory($event)
                            },
                          },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "!text-we-light !m-0 text-xs uppercase",
                            },
                            [_vm._v(_vm._s(_vm.categoryTitle))]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.algoliaLink
                  ? _c("div", { staticClass: "flex flex-col mb-2" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "self-start border border-green-500 text-green-500 text-xs uppercase border-we-light border p-1 px-3 rounded-xl leading-none w-fit max-w-max",
                          attrs: { href: _vm.algoliaLink },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onNavToCategory($event)
                            },
                          },
                        },
                        [
                          _c("p", {
                            staticClass:
                              "!text-we-light !m-0 text-xs uppercase",
                            domProps: { innerHTML: _vm._s(_vm.categoryTitle) },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", {
                  staticClass: "text-normal mb-0 font-semibold text-gray-900",
                  domProps: { innerHTML: _vm._s(_vm.slide.model_info) },
                }),
                _vm._v(" "),
                _vm.slide.sale_type != _vm.saleTypes.NO_SALE
                  ? [
                      !_vm.saleShowOnlyForCustomer ||
                      (_vm.saleShowOnlyForCustomer && !_vm.isGuest)
                        ? _c(
                            "div",
                            [
                              _vm.slide.sale_type !== _vm.saleTypes.LEASE
                                ? [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-we-light m-0 text-xs font-bold line-through",
                                      },
                                      [_vm._v(_vm._s(_vm.slide.display_price))]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.slide.sale_type === _vm.saleTypes.LEASE &&
                              _vm.slide.is_advertised_price
                                ? [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-we-light mb-1 text-lg font-semibold mt-1",
                                      },
                                      [_vm._v(_vm._s(_vm.slide.display_price))]
                                    ),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-[10px] text-white font-bold border border-we-light rounded-md bg-we-light p-1 pr-2 pl-2",
                                },
                                [_vm._v(_vm._s(_vm.salePriceLabel))]
                              ),
                              _c("br"),
                              _vm._v(" "),
                              !_vm.isLease
                                ? [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-we-light m-0 text-lg font-bold",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.slide.display_sale_price)
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._l(_vm.leasePrices, function (entity) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "flex flex-row space-x-2",
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-we-light m-0 text-lg font-bold",
                                          },
                                          [
                                            _vm._v(_vm._s(entity.value) + "/"),
                                            _c("span", [
                                              _vm._v(_vm._s(entity.period)),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                            ],
                            2
                          )
                        : _vm.saleShowOnlyForCustomer && _vm.isGuest
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-we-light m-0 font-bold flex items-center",
                              },
                              [
                                _vm.slide.sale_type !== _vm.saleTypes.LEASE
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-we-light m-0 text-xs font-bold line-through",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.slide.display_price)
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.slide.sale_type === _vm.saleTypes.LEASE &&
                                _vm.slide.is_advertised_price
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-we-light mb-1 text-lg font-semibold mt-1",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.slide.display_price)
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "text-we-light px-1 py-[3px] ml-2 border border-we-light hover:border-we rounded-md inline-flex items-center",
                                    attrs: { href: "/customer/login" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.openLogin.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text-[10px]" }, [
                                      _vm._v(
                                        _vm._s(_vm.saleButtonToLoginLabel)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "svg",
                                      {
                                        class:
                                          "ml-1 text-we-light svg-we-light w-[10px] h-[10px]",
                                        attrs: {
                                          width: "9",
                                          height: "13",
                                          viewBox: "0 0 9 13",
                                          xmlns: "http://www.w3.org/2000/svg",
                                          "svg-inline": "",
                                          role: "presentation",
                                          focusable: "false",
                                          tabindex: "-1",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d: "M.557.808a.744.744 0 00-.213.03.604.604 0 00-.18.087C.054 1.004 0 1.1 0 1.213c0 .113.055.208.164.287l7.475 5.343-7.377 5.274c-.109.078-.164.172-.164.281 0 .11.055.203.164.281.11.078.243.118.402.118.158 0 .292-.04.402-.118l7.77-5.554c.11-.079.164-.172.164-.282 0-.109-.055-.203-.164-.28L.951.924A.59.59 0 00.762.838a.772.772 0 00-.205-.03z",
                                            fill: "#26282A",
                                            "fill-rule": "evenodd",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                          ])
                        : _c(
                            "p",
                            {
                              staticClass:
                                "text-we-light mb-1 text-lg font-semibold mt-1",
                            },
                            [_vm._v(_vm._s(_vm.slide.display_price))]
                          ),
                    ]
                  : _c(
                      "p",
                      {
                        staticClass:
                          "text-we-light mb-1 text-lg font-semibold mt-1",
                      },
                      [_vm._v(_vm._s(_vm.slide.display_price))]
                    ),
              ],
              2
            )
          : _c("div", { staticClass: "flex flex-col" }, [
              _c("span", {
                staticClass: "text-xs mb-1 uppercase text-gray-900",
                domProps: { innerHTML: _vm._s(_vm.categoriesForNew) },
              }),
              _vm._v(" "),
              _c("span", {
                staticClass: "text-normal mb-0 font-semibold text-gray-900",
                domProps: {
                  innerHTML: _vm._s(`John Deere ${_vm.slide.model_number}`),
                },
              }),
            ]),
        _vm._v(" "),
        _vm.slide.meters && _vm.slide.meters.length
          ? _c(
              "p",
              {
                staticClass:
                  "flex items-center text-base leading-6 mb-1 text-gray-700 mt-1",
              },
              [_c("meters-component", { attrs: { meters: _vm.slide.meters } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.normalizeCity
          ? _c(
              "p",
              {
                staticClass:
                  "flex items-center text-base leading-6 mb-1 text-gray-700 mt-1",
              },
              [
                _c("img", {
                  staticClass: "h-4 w-4 mr-2",
                  attrs: { src: "/svg/icons/we_location.svg" },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.normalizeCity) + ", " + _vm._s(_vm.slide.state)
                  ),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.slide.stock_number
          ? _c(
              "p",
              {
                staticClass:
                  "flex items-center text-base leading-6 mb-1 text-gray-700 mt-1",
              },
              [
                _c("img", {
                  staticClass: "h-4 w-4 mr-2",
                  attrs: { src: "/svg/icons/we_serial_number.svg" },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.slide.stock_number))]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isNew && _vm.isSpecs
          ? _c(
              "div",
              { staticClass: "flex flex-col" },
              _vm._l(_vm.slide.specs, function (spec) {
                return _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center text-base leading-6 mb-1 text-gray-700 mt-1",
                  },
                  [
                    spec.value && spec.name
                      ? _c("span", { staticClass: "font-normal text-sm" }, [
                          _c("b", [_vm._v(_vm._s(spec.name) + ": ")]),
                          _vm._v(_vm._s(_vm.replaceTag(spec.value))),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("action-buttons", {
        staticClass: "flex-initial",
        attrs: { item: _vm.slide, product_type: _vm.type, "i-key": _vm.index },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "flex-initial py-2 px-4" }, [
        _c(
          "a",
          {
            staticClass:
              "flex justify-center w-full px-4 py-2 bg-we-light text-white font-bold rounded-lg",
            attrs: { href: _vm.url },
          },
          [_vm._v("VIEW")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "absolute w-full h-auto product-tags" },
        [
          _vm._l(_vm.flags, function (flag) {
            return [
              !flag.isCustom
                ? [
                    _c(
                      "div",
                      { staticClass: "product-tag", class: flag.classList },
                      [_vm._v(_vm._s(flag.title))]
                    ),
                  ]
                : [
                    flag.type === _vm.customFlags.video
                      ? _c("div", { staticClass: "product-tag yellow" }, [
                          _vm.slide.listing_video_host === "vimeo"
                            ? _c(
                                "a",
                                {
                                  staticClass: "video magnetic-popup-video",
                                  attrs: {
                                    href:
                                      "https://player.vimeo.com/video/" +
                                      _vm.slide.listing_video_id,
                                  },
                                },
                                [
                                  _vm._v("\n            Video "),
                                  _c("span", [_vm._v("▾")]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.slide.listing_video_host === "youtube"
                            ? _c(
                                "a",
                                {
                                  staticClass: "video magnetic-popup-video",
                                  attrs: {
                                    href:
                                      "https://www.youtube.com/watch?v=" +
                                      _vm.slide.listing_video_id,
                                  },
                                },
                                [
                                  _vm._v("\n            Video "),
                                  _c("span", [_vm._v("▾")]),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    flag.type === _vm.customFlags.tech
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "!bg-white product-tag !pl-4 flex items-center",
                          },
                          [
                            _c(
                              "svg",
                              {
                                class: "mr-2 h-[20px] w-auto rotate-[-5deg]",
                                attrs: {
                                  "data-name": "Layer 1",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "1400",
                                  height: "1400",
                                  viewBox: "0 0 1400 1400",
                                  "svg-inline": "",
                                  role: "presentation",
                                  focusable: "false",
                                  tabindex: "-1",
                                },
                              },
                              [
                                _c("defs", [
                                  _c("clipPath", { attrs: { id: "a" } }, [
                                    _c("path", {
                                      attrs: {
                                        fill: "none",
                                        d: "M0 0h1400v1400H0z",
                                      },
                                    }),
                                  ]),
                                ]),
                                _c("g", { attrs: { "clip-path": "url(#a)" } }, [
                                  _c("path", {
                                    attrs: {
                                      fill: "#231f20",
                                      d: "M1291.83 769.67l.07-139.03-168.6-45.33a437.196 437.196 0 00-43.22-104.41l87.34-151.21-98.26-98.36-151.3 87.19c-32.41-18.68-67.42-33.35-104.36-43.32l-45.15-168.65-139.03-.07-45.33 168.6a436.954 436.954 0 00-104.4 43.22l-151.21-87.34-98.36 98.26 87.19 151.3a437.365 437.365 0 00-43.33 104.36l-168.65 45.15-.07 139.03 168.6 45.33a436.954 436.954 0 0043.22 104.4L229.63 1070l98.26 98.36 151.3-87.19c32.41 18.68 67.42 33.35 104.36 43.32l45.15 168.65 139.03.07 45.33-168.6a436.954 436.954 0 00104.4-43.22l151.21 87.34 98.36-98.25-87.19-151.3c18.68-32.41 33.35-67.42 43.32-104.36l168.65-45.15zm-593.42 169.8c-132.34-.07-239.57-107.41-239.5-239.75.07-132.34 107.41-239.57 239.75-239.5 132.34.07 239.57 107.41 239.5 239.75-.07 132.34-107.41 239.57-239.75 239.5",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#fd0",
                                      d: "M698.41 940.25c-132.56-.07-240.34-107.97-240.27-240.52.07-132.56 107.97-240.34 240.52-240.28 132.56.07 240.34 107.97 240.28 240.52-.07 132.56-107.97 240.34-240.53 240.27m.24-451.97c-116.66-.06-211.62 94.8-211.68 211.46-.06 116.66 94.8 211.62 211.46 211.68 116.66.06 211.62-94.8 211.68-211.46.06-116.66-94.8-211.62-211.46-211.68",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      fill: "#086c00",
                                      d: "M800.23 514.36l-250.18 216.6S226.44 429.39 186.43 394.32l384.59 643.58s248.96-324.46 322.03-421.26c-18.69-43.53-51.58-79.57-92.82-102.27M1094.85 257.19l199.98-170.03-158.16 211.89c-13.87-13.97-27.85-28-41.82-41.86",
                                    },
                                  }),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-we-light font-bold" },
                              [_vm._v("Tech Reviewed")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./resources/js/Components/new/UsedCard.vue